import { useCallback, useMemo } from 'react';

/*
  useAccessibility (v2)
  - Detects reduced-motion user preference
  - Provides helpers to focus the current question heading
  - Provides an announce() helper that writes to an aria-live region
*/

export default function useAccessibility({ liveRegionRef, focusAnchorRef }) {
  const prefersReducedMotion = useMemo(() => {
    if (typeof window === 'undefined') return false;
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch { return false; }
  }, []);

  const focusQuestionHeading = useCallback(() => {
    try {
      const el = focusAnchorRef?.current;
      if (el && typeof el.focus === 'function') {
        el.setAttribute('tabindex', '-1');
        el.focus({ preventScroll: true });
      }
    } catch {}
  }, [focusAnchorRef]);

  const announce = useCallback((msg) => {
    const live = liveRegionRef?.current;
    if (!live) return;
    // Clear then set to ensure SR announcement
    live.textContent = '';
    setTimeout(() => { live.textContent = msg; }, 10);
  }, [liveRegionRef]);

  return { prefersReducedMotion, focusQuestionHeading, announce };
}


